import { render, staticRenderFns } from "./FitBox.vue?vue&type=template&id=7cb90221&scoped=true&"
import script from "./FitBox.vue?vue&type=script&lang=js&"
export * from "./FitBox.vue?vue&type=script&lang=js&"
import style0 from "./FitBox.vue?vue&type=style&index=0&id=7cb90221&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb90221",
  null
  
)

export default component.exports